import React, { useEffect, useState } from "react";
import { InstagramEmbed } from "react-social-media-embed";
import Navbar from "./Navbar";
import Footer from "./Footer";

const quotes = [
  "Empowering women engineers worldwide.",
  "Breaking barriers and building bridges.",
  "Innovation through diversity.",
  "Creating a more inclusive future.",
];

const Home = () => {
  useEffect(() => {
    // Typewriter effect implementation using pure JavaScript
    var aText = quotes;
    var iSpeed = 100; // time delay of print out
    var iIndex = 0; // start printing array at this position
    var iArrLength = aText[0].length; // the length of the text array
    var iScrollAt = 20; // start scrolling up at this many lines

    var iTextPos = 0; // initialise text position
    var sContents = ""; // initialise contents variable
    var iRow; // initialise current row

    function typewriter() {
      sContents = "";
      iRow = Math.max(0, iIndex - iScrollAt);
      var destination = document.getElementById("typedtext");

      // Check if destination element exists before accessing its properties
      if (destination) {
        while (iRow < iIndex) {
          sContents += aText[iRow++] + "<br />";
        }
        destination.innerHTML =
          sContents + aText[iIndex].substring(0, iTextPos) + "_";
        if (iTextPos++ === iArrLength) {
          iTextPos = 0;
          iIndex++;
          if (iIndex !== aText.length) {
            iArrLength = aText[iIndex].length;
            setTimeout(typewriter, 500);
          }
        } else {
          setTimeout(typewriter, iSpeed);
        }
      }
    }

    typewriter();
  }, []);

  return (
    <div>
      <div className="swe-backdrop bg-swe-purplelight min-w-screen flex-col overflow-x-hidden">
        <Navbar />
        <div className="h-auto py-10 bg-swe-purple gap-8 flex flex-wrap justify-center items-center w-full">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <InstagramEmbed
              url="https://www.instagram.com/swerutgers/"
              width={400}
            />
          </div>
          <div className="w-[55rem] bg-slate-900 text-swe-purplelight rounded-md font-mono text-sm overflow-hidden relative">
            <div className="py-5 bg-swe-purplelight flex justify-end items-center">
              <button className="w-4 h-4 rounded-full bg-red-500 mr-1"></button>
              <button className="w-4 h-4 rounded-full bg-yellow-500 mr-1"></button>
              <button className="w-4 h-4 rounded-full bg-green-500 mr-2"></button>
            </div>
            <div id="typedtext" className="px-4 py-6 text-3xl h-96"></div>
          </div>
        </div>
        <div className="flex flex-col w-screen bg-swe-purplelight py-10">
          <h2 className="swe-title text-white text-center font-bold mb-8">
            Why Join SWE?
          </h2>
          <section id="whyjoin" className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center gap-20">
              <div className="text-white text-center w-72">
                <img
                  src="imgs/icons/skills_icon.svg"
                  alt="Skills Icon"
                  className="mx-auto h-32 mb-4"
                />
                <h3 className="font-bold">Career Skills</h3>
                <p className="lead">
                  Being active in a professional organization will show your
                  future employers that you have the initiative to take on more
                  responsibility.
                </p>
              </div>
              <div className="text-white text-center w-72">
                <img
                  src="imgs/icons/network_icon.svg"
                  alt="Network Icon"
                  className="mx-auto h-32 mb-4"
                />
                <h3 className="font-bold">Networking</h3>
                <p className="lead">
                  Meeting women from companies or other universities can provide
                  you with role models and mentors.
                </p>
              </div>
              <div className="text-white text-center w-72">
                <img
                  src="imgs/icons/fun_icon.svg"
                  alt="Fun Icon"
                  className="mx-auto h-32 mb-4"
                />
                <h3 className="font-bold">Fun</h3>
                <p className="lead">
                  Meetings are both informational and social. The friends you
                  make here will go farther than just one night a week!
                </p>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
